import { REPORT_TYPE } from 'features/reports/types';

const publicPaths = {
  loginPage: (redirectedFrom?: string) =>
    `/auth/login${redirectedFrom ? `?redirectedFrom=${redirectedFrom}` : ''}`,
  keycloakAuthenticationPage: () => `/auth/keycloak-authentication`,
};

const privatePaths = {
  portalPage: () => '/',
  reportPage: (reportType: REPORT_TYPE, params?: string) =>
    `/report/${reportType}${params ? `?${params}` : ''}`,
};

const pathsMap = {
  ...publicPaths,
  ...privatePaths,
};

export type PathsMap = typeof pathsMap;

export const getPath = <TRoute extends keyof PathsMap>(
  route: TRoute,
  ...params: Parameters<PathsMap[TRoute]>
) => {
  const pathCb: (...args: any[]) => string = pathsMap[route];
  return pathCb(...params);
};
